var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgValve = function SvgValve(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36 9v2H12V9h24Zm1 4h-8v2h1c.55 0 1 .45 1 1v4c0 .55-.45 1-1 1h-1v3.57h4V23c0-.55.45-1 1-1h5c.55 0 1 .45 1 1v1.57h4c.55 0 1 .45 1 1v10.86c0 .55-.45 1-1 1h-4V39c0 .55-.45 1-1 1h-5c-.55 0-1-.45-1-1v-1.57H15V39c0 .55-.45 1-1 1H9c-.55 0-1-.45-1-1v-1.57H4c-.55 0-1-.45-1-1V25.57c0-.55.45-1 1-1h4V23c0-.55.45-1 1-1h5c.55 0 1 .45 1 1v1.57h4V21h-1c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h1v-2h-8c-.55 0-1-.45-1-1V8c0-.55.45-1 1-1h26c.55 0 1 .45 1 1v4c0 .55-.45 1-1 1ZM10 25.57V38h3V24h-3v1.57Zm-2 1H5v8.86h3v-8.86Zm25 8.86H15v-8.86h4c1.1 0 2-.9 2-2V21h6v3.57c0 1.1.9 2 2 2h4v8.86Zm5 1V24h-3v14h3v-1.57Zm2-1h3v-8.86h-3v8.86ZM21 13h6v2h-6v-2Zm7 4h-9v2h10v-2h-1Z"
  })));
};

export default SvgValve;